import React, { useState } from "react";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";

export default function LoginForm({
  initialValues,
  title,
  send,
  error,
  success,
  loading,
}) {
  const [emailVerification, setEmailVerification] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [values, setValues] = useState(initialValues);

  const handleChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };
  const history = useHistory();

  const navigate = (url) => history.push(url);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setEmailVerification(false);
    setPasswordValidation(false);

    let emailVerification = values.username; // Provisório

    // let emailVerification = new RegExp(
    //   /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g
    // ).test(values.email);

    // TO DO - Habilitar a validação quando for login por email

    let passwordValidation = new RegExp(
      /^(?=.*\d)(?=.*[a-z])(?=.*[a-zA-Z]).{8,}$/gm
    ).test(values.password);

    if (emailVerification === false) setEmailVerification(true);

    if (passwordValidation === false) setPasswordValidation(true);

    if (emailVerification && passwordValidation) send(values);
  };

  return (
    <div className="form-container">
      <div className="welcome-title">
        <h1>
          Seja bem vindo à <b className="text-primary">CTAG</b>
        </h1>
      </div>
      <form className="welcome-margin" onSubmit={handleSubmit}>
        <div className="group-input">
          <input
            placeholder="Usuário"
            className={`global-input ${
              submitted && !values.username ? "error" : ""
            }`}
            id="username"
            name="username"
            value={values.username}
            onChange={handleChange}
          />

          <div className="error-container d-flex flex-column">
            {submitted && !values.username && (
              <b className="error-msg">Esse campo é necessario</b>
            )}
            {/* 
            {emailVerification && (
              <b className="error-msg">Usuário não encontrado</b>
            )} */}
          </div>
        </div>

        <div className="group-input">
          <input
            type="password"
            placeholder="Senha"
            className={`global-input ${
              submitted && !values.password ? "error" : ""
            }`}
            id="password"
            name="password"
            value={values.password}
            onChange={handleChange}
          />
          <div className="error-container d-flex flex-column">
            {submitted && !values.password && (
              <b className="error-msg">Esse campo é necessario</b>
            )}

            {passwordValidation && (
              <b className="error-msg">
                Senha deve conter no mínimo de 8 caracteres alternados com
                letras, números e caracteres
              </b>
            )}

            {error && <b className="error-msg">{error && error}</b>}
          </div>
        </div>

        <div className="footer-form-container" style={{ marginTop: 126 }}>
          <span>
            Esqueceu a senha{" "}
            <b>
              <Link
                to="/recuperar-senha"
                className="text-dark-light text-decoration-none"
              >
                clique aqui
              </Link>
            </b>
          </span>

          <button type="submit" className="global-btn-secondary">
            ENTRAR
            {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
          </button>
        </div>
      </form>
      {/* {error && <span className="error-list">{error && error}</span>}
      {success && (
        <span className="success-msg">Enviamos um email de confirmação.</span>
      )}
      <div className="header-container">
        <div className="public-app-item">
          <h1>Seja bem vindo à <b>CTAG</b></h1>
          <p>Nós tornamos sua experiência mais fácil, maximizando seu tempo.</p>
        </div>
      </div>
      <form className="form-container" onSubmit={handleSubmit}>
        <div className="group-input">
          <label>Email</label>
          <input
            placeholder="Email *"
            className={`global-input ${
              submitted && !values.email ? "error" : ""
            }`}
            id="email"
            name="email"
            value={values.email}
            onChange={handleChange}
          />
          {submitted && !values.email && (
            <span className="error-msg">Esse campo é necessario</span>
          )}
          {emailVerification && (
            <span className="error-msg">Insira um e-mail válido</span>
          )}
        </div>
        <div className="group-input">
          <label>Senha</label>
          <input
            type="password"
            placeholder="Senha *"
            className={`global-input ${
              submitted && !values.senha ? "error" : ""
            }`}
            id="senha"
            name="senha"
            value={values.senha}
            onChange={handleChange}
          />
          {submitted && !values.senha && (
            <span className="error-msg">Esse campo é necessario</span>
          )}
          {passwordValidation && (
            <span className="error-msg">
              Senha deve conter no mínimo de 8 caracteres alternados com letras,
              números e caracteres
            </span>
          )}
        </div>
        <div className="footer-form-container">
          <div className="footer-form-item">
            <div className="link-container">
              <p>
                {" "}
                ou <a href="/cadastro">Criar conta</a>{" "}
              </p>
            </div>
          </div>
          <div className="footer-form-item">
            <button className="global-btn">
              ENTRAR
              {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
            </button>
          </div>
        </div>
      </form> */}
    </div>
  );
}
